import React from 'react'
import FormInputGroup from 'components/generic/FormInputGroup'
import InputWTN from 'components/generic/InputWTN'
import SelectWTN from 'components/generic/SelectWTN'
import { MAX_CHARS_PERSONA_DETAIL } from 'constants/registration'
import { Persona, usePersonaOptions } from 'forms/common/options'
import { useFormLabels } from 'forms/common/translations'
import { useTranslation } from 'react-i18next'
import { FormikNames } from 'types/forms/formik-names'
import styles from '../registration.module.scss'
import formStyles from '../../generic/styles/forms.module.scss'
import cx from 'classnames'

interface Props {
  persona: string
  personaDetail: string
  hasErrorPersonaDetail: boolean
}

const PersonaSelection = ({ persona, personaDetail, hasErrorPersonaDetail }: Props) => {
  const { t } = useTranslation('strCommonUI')
  const labels = useFormLabels()
  const personaOptions = usePersonaOptions()
  const charsRemainingPersonaDetail = MAX_CHARS_PERSONA_DETAIL - personaDetail.length
  const hideErrorPersonaDetail = charsRemainingPersonaDetail !== MAX_CHARS_PERSONA_DETAIL
  const hasExceededMaxCharsPersonaDetail = charsRemainingPersonaDetail < 0
  const shouldDisplayCharCount = hideErrorPersonaDetail || !hasErrorPersonaDetail
  return (
    <>
      <FormInputGroup
        label={labels.personaSelect}
        formikName={FormikNames.PERSONA}
        classWrapper={styles.inputGroup}
      >
        <SelectWTN
          id={FormikNames.PERSONA}
          options={personaOptions}
          name={FormikNames.PERSONA}
          isSearchable={false}
        />
      </FormInputGroup>
      {persona === Persona.OTHER && (
        <FormInputGroup
          label={t('form.pleaseSpecify')}
          formikName={FormikNames.PERSONA_DETAIL}
          classWrapper={styles.inputGroup}
        >
          <InputWTN
            id={FormikNames.PERSONA_DETAIL}
            name={FormikNames.PERSONA_DETAIL}
            placeholder={t('placeholder.personaDetails')}
            className={cx(styles.commonTextInput, styles.input)}
            disableErrorMessage={hideErrorPersonaDetail}
          />
          {shouldDisplayCharCount && (
            <p
              className={
                hasExceededMaxCharsPersonaDetail ? formStyles.errorMessage : styles.charsCount
              }
            >
              {hasExceededMaxCharsPersonaDetail
                ? t('form.validationErrors.maxCharsExceeded')
                : t('form.charsRemaining', { count: charsRemainingPersonaDetail })}
            </p>
          )}
        </FormInputGroup>
      )}
    </>
  )
}

export default PersonaSelection
